import { urls } from '@zapier/identity-utils';
import { atoms, Link } from '@zapier/marketing-ui';

export function Legal() {
  return (
    <p className={`${atoms.bodySM} ${atoms.textNeutral800}`}>
      By signing up, you agree to Zapier&apos;s{' '}
      {
        <Link href={urls.LEGAL_URL} target="_blank">
          terms of service
        </Link>
      }{' '}
      and{' '}
      {
        <Link href={urls.PRIVACY_URL} target="_blank">
          privacy policy.
        </Link>
      }
    </p>
  );
}
